<script setup lang="ts">
import { FontAwesomeIcon } from '@shared/plugin/icons';
import { VTooltip } from '@shared/component/VTooltip';
import { tryFormatDate } from '@tools/dates';
import { type UboMetCheckResultaat } from '@relatie-lib/ubo/types';
import { hasPermission } from '@permission/hasPermission';
import { computed, ref } from 'vue';
import UboResultaatOverschrijvenModal from '@relatie-lib/ubo/UboResultaatOverschrijvenModal.vue';

const ubo = defineModel<UboMetCheckResultaat>({ required: true });

const magResultaatOverschrijven = hasPermission('Crm.UboResultaatOverschrijven');
const kanResultaatOverschrijven = computed(
  () =>
    magResultaatOverschrijven.value &&
    ubo.value.isResultaatGeldig &&
    ubo.value.resultaat === 'Afgekeurd',
);

const isOverschrijvenModalOpen = ref<boolean>(false);
function openOverschrijvenModal() {
  if (!kanResultaatOverschrijven.value) {
    return;
  }
  isOverschrijvenModalOpen.value = true;
}
</script>

<template>
  <VTooltip>
    <component :is="kanResultaatOverschrijven ? 'button' : 'div'" @click="openOverschrijvenModal">
      <FontAwesomeIcon
        v-if="ubo.isResultaatGeldig && ubo.resultaat === 'Goedgekeurd'"
        size="lg"
        icon="far fa-check-circle"
        class="rounded-full bg-white text-primary"
        aria-label="Ubo goedgekeurd"
      />
      <FontAwesomeIcon
        v-else-if="!ubo.isResultaatGeldig"
        size="lg"
        icon="far fa-circle-minus"
        class="rounded-full bg-white text-orange"
        aria-label="Ubo status onbekend"
      />
      <FontAwesomeIcon
        v-else
        size="lg"
        icon="far fa-xmark-circle"
        class="rounded-full bg-white text-red"
        aria-label="Ubo afgekeurd"
      />
    </component>

    <template #content>
      <span v-if="!ubo.laatstGecheckt">Check nog niet uitgevoerd.</span>
      <template v-else>
        <span>
          Check voor het laatst uitgevoerd op:
          <strong class="whitespace-nowrap">{{ tryFormatDate(ubo.laatstGecheckt) }}</strong>
        </span>

        <template v-if="!ubo.isResultaatGeldig">
          <hr />
          <span> Resultaat is niet meer geldig en check dient opnieuw uitgevoerd te worden. </span>
        </template>
        <template v-else-if="kanResultaatOverschrijven">
          <hr />
          Klik op het icoon om de UBO alsnog goed te keuren.
        </template>
      </template>
    </template>
  </VTooltip>

  <UboResultaatOverschrijvenModal v-model="ubo" v-model:is-open="isOverschrijvenModalOpen" />
</template>
